import React from 'react';
import { Container } from './styles';
import HandleTrade from 'common/HandleTrade';

const ChooseTrade = (): JSX.Element => {
  return (
    <Container>
      <HandleTrade />
    </Container>
  );
};

export default ChooseTrade;
